import { useStatsig } from '@atlassian/mpac-feature-flags';

export const useRegulatedSectorFeatureFlags = () => {
  const { enableRegulatedSectorMenuButtonForFedramp, enableRegulatedSectorButtonForIsolatedCloud } =
    useStatsig();
  return {
    showFedrampNavigationMenuButton: enableRegulatedSectorMenuButtonForFedramp(),
    showIsolatedCloudNavigationMenuButton: enableRegulatedSectorButtonForIsolatedCloud(),
  };
};
